<template>
  <div class="d-flex justify-center">
    <div class="_60_w" v-if="dataSet">
      <v-card class="rounded_max" elevation="1" style="overflow: hidden">
        <div class="strip" style="`#006341`"></div>
        <div class="d-flex justify-space-between px-2 mb-2">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" small icon @click="$router.go(-1)"
                ><v-icon>mdi-reply</v-icon></v-btn
              >
            </template>
            <span>Back</span>
          </v-tooltip>
          <!-- <v-btn icon color="red" @click="deleteModule($route.params.idModule)">
            <v-icon>mdi-delete</v-icon>
          </v-btn> -->
        </div>
        <div class="px-5 pb-5" v-if="dataSet">
          <p class="default_txt">Module Title</p>
          <v-text-field
            :disabled="
              permissions.includes('LD') ||
              role == 'SUPERADMIN' ||
              role == 'VENDOR'
                ? false
                : true
            "
            placeholder="Type Here"
            hide-details
            v-model="dataSet.name"
            @blur="updateTools"
            color="#006341"
            style="font-size: 30px"
          ></v-text-field>
          <p class="default_txt mt-5">Description</p>
          <v-textarea
            :disabled="
              permissions.includes('LD') ||
              role == 'SUPERADMIN' ||
              role == 'VENDOR'
                ? false
                : true
            "
            dense
            placeholder="Type Here"
            v-model="dataSet.description"
            hide-details
            @blur="updateTools"
            rows="2"
            auto-grow
            color="#006341"
          ></v-textarea>

          <v-row no-gutters>
            <v-col cols="3">
              <p class="default_txt mt-3">Time</p>
              <v-text-field
                :disabled="
                  permissions.includes('LD') ||
                  role == 'SUPERADMIN' ||
                  role == 'VENDOR'
                    ? false
                    : true
                "
                placeholder="Type Here"
                hide-details
                class="ma-0 pa-0"
                type="number"
                @blur="updateTools"
                v-model="dataSet.time"
                :color="color"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <div class="pa-2 d-flex justify-end">
          <p class="default_txt">{{ msg }}</p>
        </div>
      </v-card>
      <v-card class="pa-3 rounded_max mt-3" elevation="1">
        <v-row no-gutters>
          <v-col cols="12" md="7" lg="7" sm="12">
            <div class="pa-3">
              <p class="default_txt">Question</p>
              <v-text-field
                :disabled="
                  permissions.includes('LD') ||
                  role == 'SUPERADMIN' ||
                  role == 'VENDOR'
                    ? false
                    : true
                "
                dense
                v-model="question.question"
                placeholder="Type Here"
                hide-details="auto"
                :error-messages="err.question.txt"
                :color="color"
              ></v-text-field>
            </div>
          </v-col>
          <v-col cols="12" md="5" lg="5" sm="12">
            <div class="pa-3">
              <p class="default_txt">Type Question</p>
              <v-select
                :disabled="
                  permissions.includes('LD') ||
                  role == 'SUPERADMIN' ||
                  role == 'VENDOR'
                    ? false
                    : true
                "
                dense
                hide-details="auto"
                :items="listType"
                v-model="question.type"
                placeholder="Click Here"
                flat
                :color="color"
              ></v-select>
            </div>
          </v-col>
        </v-row>
        <div class="mt-3" v-if="question.type == 'multiple'">
          <v-row
            no-gutters
            v-for="(opt, i) in question.option"
            :key="`opt-${i}`"
          >
            <v-col cols="1" md="1">
              <div class="d-flex align-end pa-2" style="height: 100%">
                <v-icon>mdi-radiobox-blank</v-icon>
              </div>
            </v-col>
            <v-col cols="6" md="6">
              <div class="pa-2">
                <div>
                  <v-text-field
                    :disabled="
                      permissions.includes('LD') ||
                      role == 'SUPERADMIN' ||
                      role == 'VENDOR'
                        ? false
                        : true
                    "
                    dense
                    v-model="opt.val"
                    placeholder="Type Here"
                    :ref="`opt-${opt.key}`"
                    hide-details
                    :color="color"
                    @focus="firstSelect(opt, i)"
                    @keyup.enter="addOpt(question.option)"
                  ></v-text-field>
                </div>
              </div>
            </v-col>
            <v-col
              cols="2"
              v-if="
                permissions.includes('LD') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
              "
            >
              <div
                class="d-flex align-end pa-2"
                style="height: 100%"
                v-if="question.option.length > 1"
              >
                <v-btn small icon class="pa-0" @click="delOpt(opt)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="1" md="1">
              <div class="d-flex align-end pa-2" style="height: 100%">
                <v-icon>mdi-radiobox-blank</v-icon>
              </div>
            </v-col>
            <v-col cols="6" md="6">
              <div class="pa-2">
                <v-btn
                  :disabled="
                    permissions.includes('LD') ||
                    role == 'SUPERADMIN' ||
                    role == 'VENDOR'
                      ? false
                      : true
                  "
                  class="text-capitalize py-1 px-0"
                  text
                  height="max-content"
                  max-width="max-content"
                  @click="addOpt(question.option)"
                  >Add option</v-btn
                >
              </div>
            </v-col>
          </v-row>
          <div class="px-3">
            <p class="small_txt red--text ma-0 mt-1">
              {{ err.opt.txt }}
            </p>
          </div>
          <div style="height: 20px"></div>
        </div>
      </v-card>
      <div
        class="d-flex justify-end mt-4"
        v-if="
          permissions.includes('LD') || role == 'SUPERADMIN' || role == 'VENDOR'
        "
      >
        <v-btn
          v-if="!creating"
          :class="` text-capitalize rounded-lg`"
          depressed
          dark
          :color="color"
          @click="validateCreate"
          >Add Question</v-btn
        >
        <v-btn
          v-if="creating"
          :class="` text-capitalize rounded-lg`"
          depressed
          dark
          :color="color"
          >Loading...</v-btn
        >
      </div>
      <div v-if="listQuest">
        <div class="mt-3">
          <draggable
            v-model="listQuest"
            class="list-group"
            @start.prevent="drag = true"
            @end="draged"
            v-bind="dragOptions"
            handle=".handle"
          >
            <transition-group
              type="transition"
              :name="!drag ? 'flip-list' : null"
            >
              <v-card
                class="rounded_max mb-3"
                v-for="(quiz, i) in listQuest"
                :key="`quin-in-${i}`"
              >
                <div
                  class="d-flex justify-center handle"
                  v-if="
                    permissions.includes('LD') ||
                    role == 'SUPERADMIN' ||
                    role == 'VENDOR'
                  "
                >
                  <v-btn icon small style="cursor: move">
                    <v-icon>mdi-drag-horizontal </v-icon>
                  </v-btn>
                </div>
                <div class="px-5 pt-3 pb-3">
                  <h3>{{ quiz.question }}</h3>
                  <div class="mt-3" v-if="quiz.type == 'multiple'">
                    <v-radio-group disabled>
                      <v-radio
                        v-for="(opt, n) in quiz.choice"
                        :key="`opt-${n}`"
                        :value="opt.index"
                        :label="opt.jawaban"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </div>
                <div
                  class="d-flex justify-end pa-2"
                  v-if="
                    permissions.includes('LD') ||
                    role == 'SUPERADMIN' ||
                    role == 'VENDOR'
                  "
                >
                  <v-btn
                    icon
                    :color="color"
                    small
                    @click="updateQuestion(quiz)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </transition-group>
          </draggable>
          <v-snackbar v-model="sorting" left :timeout="-1">
            {{ msg }}
          </v-snackbar>
        </div>
      </div>
      <div class="pa-2">
        <dialog-medium
          :d_create="d_create"
          @refetch="fetchData"
          @close="d_create = false"
          :inventory="inventory"
          :type="d_type"
          :title="d_title"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import draggable from "vuedraggable";
// import DialogMedium from "../dialog/dialogMedium.vue";
export default {
  name: "quizModule",
  data() {
    return {
      loading: false,
      msg: "",
      listType: ["multiple", "essay"],
      listQuest: null,
      dataSet: null,
      color: "#006341",
      getAway: false,
      err: {
        question: {
          txt: "",
          status: 0,
        },
        opt: {
          txt: "",
          status: 0,
        },
      },
      drag: false,
      sorted: [],
      sorting: false,
      creating: false,
      question: {
        type: "multiple",
        question: "",
        option: [
          {
            key: "a",
            val: "Option",
          },
        ],
        answer: "",
      },
      d_create: false,
      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",
    };
  },
  components: {
    draggable,
    // DialogMedium
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  props: ["module"],
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/assessment?filter[id]=${this.$route.params.id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data[0];
          this.fetchQuest();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchQuest() {
      this.loading = true;
      let data = {
        path: `manage/assessment/test?assessment_tools_id=${this.$route.params.id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.listQuest = data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    updateTools() {
      this.msg = "saving..";
      let body = {
        assessment_tools_id: this.dataSet.id,
        name: this.dataSet.name,
        time: this.dataSet.time,
        description: this.dataSet.description,
      };
      let data = {
        path: `manage/assessment/update`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then(() => {
          this.msg = "";
        })
        .catch((err) => {
          this.msg = "Error";
        });
    },
    validateCreate() {
      let vm = this;
      if (vm.question.question == "") {
        vm.err.question.txt = "Question cannot be empty";
        vm.err.question.status = 1;
      } else {
        vm.err.question.txt = "";
        vm.err.question.status = 0;
      }
      if (vm.question.type == "multiple") {
        if (vm.question.option.length <= 1) {
          vm.err.opt.txt = "choice must be more than 1";
          vm.err.opt.status = 1;
        }
      }
      let count = 0;
      for (let i in vm.err) {
        count = count + vm.err[i].status;
      }
      if (count == 0) {
        this.createQuestion();
      }
    },
    createQuestion() {
      this.creating = true;
      let dataQuiz = null;
      let choice = "";
      let vm = this;
      if (vm.question.type == "multiple") {
        vm.question.option.forEach((el, i) => {
          choice =
            choice +
            `${el.key}:${el.val}${
              i !== vm.question.option.length - 1 ? ";" : ""
            }`;
        });
        dataQuiz = {
          type: vm.question.type,
          question: vm.question.question,
          choice: choice,
        };
      } else {
        dataQuiz = {
          type: vm.question.type,
          question: vm.question.question,
        };
      }
      let body = {
        assessment_tools_id: this.dataSet.id,
        data_soal: JSON.stringify([dataQuiz]),
      };
      let data = {
        path: `manage/assessment/question-create`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.question = {
            type: "multiple",
            question: "",
            option: [
              {
                key: "a",
                val: "Option",
              },
            ],
            answer: "",
          };
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.creating = false;
          this.fetchQuest();
        })
        .catch((err) => {
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
          this.creating = false;
        });
    },
    addOpt(list) {
      this.err.opt.txt = "";
      let char = list[list.length - 1].key;
      let next = String.fromCharCode(char.charCodeAt(0) + 1);
      this.question.option.push({
        key: next,
        val: `New Option`,
      });
      setTimeout(() => {
        this.$refs[`opt-${next}`][0].$refs.input.focus();
        this.$refs[`opt-${next}`][0].$refs.input.select();
      }, 100);
    },
    firstSelect(item) {
      this.$refs[`opt-${item.key}`][0].$refs.input.select();
    },
    delOpt(item) {
      const index = this.question.option.indexOf(item);
      if (index > -1) {
        this.question.option.splice(index, 1);
        this.question.option.forEach((item, i) => {
          item.key = (i + 10).toString(36);
        });
      }
    },
    draged() {
      this.drag = false;
      this.listQuest.forEach((el, idx) => {
        let obj = {
          id: el.id,
          weight: idx + 1,
        };
        this.sorted.push(obj);
      });
      this.switchOrder();
    },
    switchOrder() {
      this.msg = "moving question...";
      this.sorting = true;
      let body = {
        assessment_tools_id: this.dataSet.id,
        data_question: this.sorted,
      };
      let data = {
        path: `manage/assessment/weight/switch`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then((data) => {
          this.msg = "question moved";
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          setTimeout(() => {
            this.sorting = false;
          }, 800);
        })
        .catch((err) => {
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
          this.msg = "Error";
          setTimeout(() => {
            this.sorting = false;
          }, 800);
        });
    },
    updateQuestion(item) {
      this.d_type = "u_qtools";
      this.d_title = "Update Question";
      item["color"] = this.color;
      this.inventory = item;
      this.d_create = true;
    },
  },
};
</script>

<style></style>
